import { Card, CardContent, CircularProgress, Stack } from "@mui/material";
import { LoadingComponentProps } from "./LoadingComponent.types";

const LoadingComponent = ({
	color = "primary",
	customColor = null,
	size = 40,
	noElevation = false,
	transparent = false
}: LoadingComponentProps) => {
	return (
		<Card elevation={noElevation ? 0 : undefined} style={transparent ? { backgroundColor: 'transparent' } : {}}>
			<CardContent sx={{ p: 2 }}>
				<Stack direction={"row"} justifyContent={"center"}>
					<CircularProgress sx={{ color: customColor ?? undefined }} color={customColor ? undefined : color} size={size} />
				</Stack>
			</CardContent>
		</Card>
	)
};

export default LoadingComponent